import { useTranslation } from '@gimlite/common';
import {
  Timeline,
  TimelineType,
} from '../../components/timeline/timeline.component';

export declare namespace EnteredSessionTimelineType {
  type Props = {
    data: {
      date: TimelineType.Data.Date;
      device: TimelineType.Data.Device;
    };
  };
}

export const EnteredSessionTimeline = ({
  data: { date, device },
}: EnteredSessionTimelineType.Props) => {
  const { t } = useTranslation();
  return (
    <Timeline
      config={{
        color: 'success',
      }}
      data={{
        date,
        device,
        title: t('global-state-entered'),
      }}
    />
  );
};
